/**************************************************
 * Nombre:       Formulario_Escuela_Beneficios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjetas_Beneficios from "../../Tarjeta/Tarjetas_Beneficios";
import Formulario_Escuela_Beneficios_Beneficio from "./Formulario_Escuela_Beneficios_Beneficio";

const Formulario_Escuela_Beneficios = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Ingresar Beneficio',
        dato: 'beneficios',
        Tarjeta: Tarjetas_Beneficios,
        Formulario: Formulario_Escuela_Beneficios_Beneficio
    });


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Escuela_Beneficios